import { render, staticRenderFns } from "./ModalAreaTexto.vue?vue&type=template&id=69629b43&scoped=true"
import script from "./ModalAreaTexto.vue?vue&type=script&lang=js"
export * from "./ModalAreaTexto.vue?vue&type=script&lang=js"
import style0 from "./ModalAreaTexto.vue?vue&type=style&index=0&id=69629b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69629b43",
  null
  
)

export default component.exports